var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionAlertRejectrion = function SvgGeneralActionAlertRejectrion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 9.75c0-4.549-3.701-8.25-8.25-8.25S4 5.201 4 9.75v6.75c0 1.654 1.346 3 3 3h1.576c.348 1.71 1.863 3 3.674 3a3.756 3.756 0 0 0 3.674-3H20.5zM19 18H7c-.827 0-1.5-.673-1.5-1.5V9.75A6.76 6.76 0 0 1 12.25 3 6.76 6.76 0 0 1 19 9.75zm-8.861 1.5c.31.872 1.135 1.5 2.111 1.5s1.8-.628 2.112-1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.662 1.777 1.06 1.06L3.339 21.224l-1.06-1.061z"
  }))));
};
export default SvgGeneralActionAlertRejectrion;